import React from 'react'
import { Badge } from '@/components/ui/badge'
import type { Tag } from '@/payload-types'

interface VacancyTagProps {
  tag: string | number | Tag
  variant?: 'default' | 'secondary' | 'destructive' | 'outline' | 'primary'
}

export function VacancyTag({ tag, variant = 'primary' }: VacancyTagProps) {
  const tagData = typeof tag === 'object' ? tag : null

  if (!tagData) return null

  return (
    <Badge variant={variant} className="text-sm">
      {tagData.name}
    </Badge>
  )
}

interface VacancyTagListProps {
  tags: (string | number | Tag)[] | null | undefined
  className?: string
  variant?: 'default' | 'secondary' | 'destructive' | 'outline' | 'primary'
}

export function VacancyTagList({ tags, className, variant = 'primary' }: VacancyTagListProps) {
  if (!tags || tags.length === 0) return null

  return (
    <div className={className}>
      {tags.map((tag) => {
        const tagData = typeof tag === 'object' ? tag : null
        return tagData ? <VacancyTag key={tagData.id} tag={tag} variant={variant} /> : null
      })}
    </div>
  )
}
